import { render } from "./NoticeBar.vue?vue&type=template&id=7aa69e5a&scoped=true"
import script from "./NoticeBar.vue?vue&type=script&lang=js"
export * from "./NoticeBar.vue?vue&type=script&lang=js"

import "./NoticeBar.vue?vue&type=style&index=0&id=7aa69e5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aa69e5a"]])

export default __exports__